import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { useShopifyOfferContext } from '../../offer/shopifyContext';
import {
  StyledHeroStats,
  StatsBlock,
  StatValue,
  StatLabel,
  Divider,
} from './styles.js';

export const HeroStats = ({
  stats,
  backgroundColor = 'background.lightest',
  fontColor = 'text.lightest',
  transparent = false,
}) => {
  const lastIndex = stats?.length - 1;
  const { formattedAmount } = useShopifyOfferContext();

  return (
    <StyledHeroStats
      $backgroundColor={backgroundColor}
      $fontColor={fontColor}
      $transparent={transparent}
    >
      {stats?.map((item, index) => (
        <Fragment key={index}>
          <StatsBlock $transparent={transparent} $statCount={stats.length}>
            <StatValue $transparent={transparent}>
              {interpolate(item.value, { offer: formattedAmount })}
            </StatValue>
            <StatLabel $transparent={transparent}>
              {interpolate(item.label, { offer: formattedAmount })}
            </StatLabel>
          </StatsBlock>
          {index !== lastIndex && <Divider $transparent={transparent} />}
        </Fragment>
      ))}
    </StyledHeroStats>
  );
};

HeroStats.displayName = 'HeroStats';

HeroStats.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
  transparent: PropTypes.bool,
};
